module.exports = __webpack_public_path__ + "static/img/exit_icon.1d887619.png";